import { createAsyncAction, createAction } from 'typesafe-actions';
import { createPromiseAction } from 'redux-saga-promise-actions';

import { User } from 'models/User';
import { LoggedUserResponse } from 'store/types/users';

export const getUser = createPromiseAction('GET_USER', 'GET_USER_SUCCEEDED', 'GET_USER_FAILURE')<
  undefined,
  User,
  undefined
>();

export const setUser = createAction('SET_USER', (user: User | null) => user)<User | null>();

export const restoreUserData = createAsyncAction(
  'RESTORE_USER_DATA',
  'RESTORE_USER_DATA_SUCCEEDED',
  'RESTORE_USER_DATA_FAILURE',
)<undefined, User, undefined>();

export const loggedInUser = createPromiseAction(
  'LOGGED_IN_USER_REQUEST',
  'LOGGED_IN_USER_REQUEST_SUCCEEDED',
  'LOGGED_IN_USER_REQUEST_FAILURE',
)<undefined, LoggedUserResponse, undefined>();
